import { History } from "history";
import {
  AppSettingsDto,
  ContactUsRequest,
  DeleteAccountRequest,
  GenerateSequenceNumberRequest,
  GenerateSequenceNumberResponse,
  UpdateAppSettingsRequest,
} from "../../interfaces/app-settings";
import { AppSettingsTypeEnum, SequenceEnum } from "../../enums";

//#region Get App Setting

export const GET_APP_SETTINGS = "GET_APP_SETTINGS";
export const GET_APP_SETTINGS_SUCCESS: any = "GET_APP_SETTINGS_SUCCESS";
export const GET_APP_SETTINGS_ERROR: any = "GET_APP_SETTINGS_ERROR";

export interface GetAppSettingsAction {
  type: typeof GET_APP_SETTINGS;
  payload: {
    type: AppSettingsTypeEnum;
    history: History;
  };
}

export interface GetAppSettingsSuccessAction {
  type: typeof GET_APP_SETTINGS_SUCCESS;
  payload: AppSettingsDto;
}

export interface GetAppSettingsErrorAction {
  type: typeof GET_APP_SETTINGS_ERROR;
  payload: any;
}
//#endregion

//#region Update App Setting

export const UPDATE_APP_SETTINGS = "UPDATE_APP_SETTINGS";
export const UPDATE_APP_SETTINGS_SUCCESS: any = "UPDATE_APP_SETTINGS_SUCCESS";
export const UPDATE_APP_SETTINGS_ERROR: any = "UPDATE_APP_SETTINGS_ERROR";

export interface UpdateAppSettingsAction {
  type: typeof UPDATE_APP_SETTINGS;
  payload: {
    type: AppSettingsTypeEnum;
    request: UpdateAppSettingsRequest;
    history: History;
  };
}

export interface UpdateAppSettingsSuccessAction {
  type: typeof UPDATE_APP_SETTINGS_SUCCESS;
  payload: AppSettingsDto;
}

export interface UpdateAppSettingsErrorAction {
  type: typeof UPDATE_APP_SETTINGS_ERROR;
  payload: any;
}
//#endregion

//#region Generate Sequence number

export const GENERATE_SEQUENCE_NUMBER = "GENERATE_SEQUENCE_NUMBER";
export const GENERATE_SEQUENCE_NUMBER_SUCCESS: any =
  "GENERATE_SEQUENCE_NUMBER_SUCCESS";
export const GENERATE_SEQUENCE_NUMBER_ERROR: any =
  "GENERATE_SEQUENCE_NUMBER_ERROR";

export interface GenerateSequenceNumberAction {
  type: typeof GENERATE_SEQUENCE_NUMBER;
  payload: GenerateSequenceNumberRequest;
}

export interface GenerateSequenceNumberSuccessAction {
  type: typeof GENERATE_SEQUENCE_NUMBER_SUCCESS;
  payload: GenerateSequenceNumberResponse;
}

export interface GenerateSequenceNumberErrorAction {
  type: typeof GENERATE_SEQUENCE_NUMBER_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetAppSettingsAction
  | GetAppSettingsSuccessAction
  | GetAppSettingsErrorAction
  | UpdateAppSettingsAction
  | UpdateAppSettingsSuccessAction
  | UpdateAppSettingsErrorAction;
